import { Injectable, inject } from '@angular/core';
import { TslApiService } from 'projects/aztalena-core/src/public-api';
import { Observable } from 'rxjs';
import { AvatarSlot } from '../user/tribe';

@Injectable({
  providedIn: 'root'
})
export class AvatarService {
  private api = inject(TslApiService);

  getCharacterParts(): Observable<AvatarSlot[]> {
    return this.api.get<AvatarSlot[]>('avatar/character-parts');
  }

  getUserSelectedParts(): Observable<{ [slotId: string]: string }> {
    return this.api.get('avatar/user-parts');
  }

  buyParts(avatarPartIds: string[]): Observable<void> {
    return this.api.post('avatar/buy-parts', { avatarPartIds });
  }
}
